import React, { useEffect, useRef, useState } from 'react';
import { Input } from '@/components/Input';
import CustomSelectEx from '@/ctComponents/CustomSelectEx';
import CloseButton from '@/ctComponents/closeButton';
import SubmitButton from '@/ctComponents/submitButton';
import clsx from 'clsx';

export default ({
  DATA = [],
  filter = {},
  setFilter,
  setDATA,
  notify,
  setFilterForm,
}) => {
  const statusOp = [
    {
      label: 'Registered',
      value: 1,
    },
    {
      label: 'Active',
      value: 2,
    },
    {
      label: 'Deactive',
      value: 3,
    },
    {
      label: 'Suspended',
      value: 0,
    },
  ];

  const defaultForm = {
    name: null,
    last_name: null,
    email: null,
    phone: null,
    company: null,
    status: null,
  };

  const [submitLoading, setSubmitLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [form, setFormData] = useState(defaultForm);
  const filterWrapperRef = useRef(null);

  const setForm = (i, v) => setFormData({ ...form, [i]: v });

  useEffect(() => {
    // Sync form with appliedFilters when they change
    const appliedFilters = filter?.appliedFilters;
    if (appliedFilters) {
      setFormData({
        name: appliedFilters.name || null,
        last_name: appliedFilters.last_name || null,
        email: appliedFilters.email || null,
        phone: appliedFilters.phone || null,
        company: appliedFilters.company || null,
        status: appliedFilters.status || null,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter?.appliedFilters]);

  useEffect(() => {
    if (filterWrapperRef.current) {
      if (filter.open) {
        filterWrapperRef.current.style.maxHeight =
          filterWrapperRef.current.scrollHeight + 'px';
        filterWrapperRef.current.style.opacity = '1';
      } else {
        filterWrapperRef.current.style.maxHeight = '0px';
        filterWrapperRef.current.style.opacity = '0';
      }
    }
  }, [filter.open]);

  const Filter = () => {
    setSubmitLoading(true);
    // Remove null/empty values
    const cleanedForm = Object.fromEntries(
      Object.entries(form).filter(
        ([_, v]) => v !== null && v !== '' && v !== undefined
      )
    );

    setFilterForm(cleanedForm);
    setFilter({
      ...filter,
      open: false,
      appliedFilters: {
        ...filter.appliedFilters,
        ...cleanedForm,
      },
    });
    setTimeout(() => {
      setSubmitLoading(false);
    }, 100);
  };

  const Reset = () => {
    setResetLoading(true);
    setFormData(defaultForm);

    setFilter({
      ...filter,
      open: false,
      appliedFilters: {
        ...defaultForm,
      },
    });

    setTimeout(() => {
      setFilter({ ...filter, appliedFilters: {} });
      setFormData(defaultForm);
      setResetLoading(false);
    }, 100);
  };

  return (
    <div
      ref={filterWrapperRef}
      className="transition-all duration-500 ease-in-out overflow-hidden">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 p-4 bg-white border shadow-custom-plan border-solid rounded border-border-tertiary">
        <Input
          type="text"
          placeholder="First Name"
          value={form.name || ''}
          onChange={(e) => setForm('name', e.target.value)}
          height={48}
          className={clsx('w-full')}
        />

        <Input
          type="text"
          placeholder="Last Name"
          value={form.last_name || ''}
          onChange={(e) => setForm('last_name', e.target.value)}
          height={48}
          className={clsx('w-full')}
        />

        <Input
          type="email"
          placeholder="Email"
          value={form.email || ''}
          onChange={(e) => setForm('email', e.target.value)}
          height={48}
          className={clsx('w-full')}
        />

        <Input
          type="text"
          placeholder="Phone"
          value={form.phone || ''}
          onChange={(e) => setForm('phone', e.target.value)}
          height={48}
          className={clsx('w-full')}
        />

        <Input
          type="text"
          placeholder="Company"
          value={form.company || ''}
          onChange={(e) => setForm('company', e.target.value)}
          height={48}
          className={clsx('w-full')}
        />

        <CustomSelectEx
          dropdown
          isClearable
          placeholder="Status"
          className={clsx('w-full')}
          value={
            form.status !== null && form.status !== ''
              ? statusOp.find((op) => op.value === form.status)
              : null
          }
          onChange={(item) => setForm('status', item?.value ?? null)}
          options={statusOp}
          height={48}
          maxHeight={48}
        />

        <div className="flex items-center justify-end gap-2 sm:col-span-2 lg:col-span-2">
          <CloseButton
            color={'#131517'}
            text={'Reset'}
            onClick={Reset}
            loading={resetLoading}
          />
          <SubmitButton text="Apply" loading={submitLoading} onClick={Filter} />
        </div>
      </div>
      <div className="h-4 w-full" />
    </div>
  );
};
